import { gql } from '@apollo/client';

export const REFRESH_USER_ACCESS_TOKEN = gql`
	mutation LoginUser($credentials: RefreshUserTokenDto!) {
		refreshUserAccessToken(credentials: $credentials) {
			access_token
		}
	}
`;

// refreshToken: Success! //access/refresh одразу сетиться в куки (без видимого респонса)
export const REFRESH_USER_ACCESS_TOKEN_V2 = gql`
	mutation RefreshUserAccessTokenV2 {
		refreshToken {
			success
		}
	}
`;